import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zag-card-footer',
  templateUrl: './zag-card-footer.component.html',
  styleUrl: './zag-card-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZagCardFooterComponent {}
